import React, { useEffect, useState } from "react";
import { useCallback } from "react";
import { TOptionType } from "../../../types/CustomSelect";
import Multiselect from "multiselect-react-dropdown";
import CustomArrow from "../../../utils/CustomStyleComponent/ArrowComponent";
import CustomCrossButton from "../../../utils/CustomStyleComponent/CrossButtonComponent";
import { toast } from "react-toastify";
import { TSubCategoryFilterProps } from "../../../types/Filters/SubCategory";
import { getCategory } from "../../../generatedRequest/category";
import { getSubCategory } from "../../../generatedRequest/subcategory";
import CustomTooltip1 from "../../../utils/CustomStyleComponent/TooltipNewComponent";
import "../../../app/pages/Units/UnitsForm.css";

const SubCategoryFilter = ({
  onSubCategoryFilterChange,
  currentSubCategoryFilter,
  showOnlyProductSubCategory,
}: TSubCategoryFilterProps) => {
  const [allSubCategory, setAllSubCategory] = useState<Array<{ id: string; subcategoryName: string; isProductSubcategory?: boolean }>>([]);

  const style = {
    multiSelectContainer: {
      minheight: "44px",

      border: "1px solid var(--bs-gray-100)",

      // styles for the multiselect container
    },
    searchBox: {
      minheight: "44px",
      fontWeight: "500",
      minwidth: "40px",
      maxwidth: "40px",
      height: "44px",
      display: "flex",
      alignItems: "center",
      width: "350px",

      // styles for the search wrapper
    },
    chips: {
      // To change css chips(Selected options)
      marginBottom: "0",
    },
  };

  useEffect(() => {
    const fn = async () => {
      const searchQuery = `page=1&limit=100`;
      try {
        const response = await getSubCategory(searchQuery);
        if (response.data.status) {
          // Map the response to match your interface (id instead of _id)
          const mappedData = response.data.data.data.map((item: any) => ({
            ...item,
            id: item._id, // Map _id to id
          }));

          if (showOnlyProductSubCategory) {
            setAllSubCategory(
              mappedData.filter(
                (subcategory: any) => subcategory?.isProductSubcategory
              )
            );
          } else {
            setAllSubCategory(mappedData);
          }
        } else {
          toast.error("Something went wrong");
        }
      } catch (error) {
        toast.error("Network Error");
      } finally {
      }
    };
    fn();
  }, []);

  const handleSubCategoryFilter = useCallback((data: any) => {
    onSubCategoryFilterChange(data);
  }, []);

  // Function to get selected values based on currentSubCategoryFilter
  const getSelectedValues = () => {
    if (currentSubCategoryFilter) {
      console.log('Current SubCategory Filter:', currentSubCategoryFilter);
      console.log('All SubCategories:', allSubCategory);

     
      try {
       
        const filterValue = String(currentSubCategoryFilter);
        
        
        if (typeof currentSubCategoryFilter === 'string' || filterValue) {
          
          const filterValues = filterValue.split(',').map((val: string) => val.trim());
          console.log('Filter Values:', filterValues);

          return allSubCategory.filter(subcategory =>
            filterValues.includes(subcategory.id) ||
            filterValues.includes(subcategory.subcategoryName)
          );
        }
       
        else if (Array.isArray(currentSubCategoryFilter) && currentSubCategoryFilter.length > 0) {
          return allSubCategory.filter(subcategory =>
            currentSubCategoryFilter.some((filterSubCategory: any) =>
              subcategory.subcategoryName === filterSubCategory ||
              subcategory.id === filterSubCategory ||
              (typeof filterSubCategory === 'object' &&
                (subcategory.subcategoryName === filterSubCategory.subcategoryName ||
                  subcategory.id === filterSubCategory.id))
            )
          );
        }
      
        else if (typeof currentSubCategoryFilter === 'object' && !Array.isArray(currentSubCategoryFilter)) {
          const filterObj = currentSubCategoryFilter as { subcategoryName?: string; id?: string };
          return allSubCategory.filter(subcategory =>
            subcategory.subcategoryName === filterObj.subcategoryName ||
            subcategory.id === filterObj.id
          );
        }
      } catch (error) {
        console.error('Error processing filter:', error);
      }
    }
    return [];
  };

  return (
    <Multiselect
      options={allSubCategory}
      displayValue="subcategoryName"
      placeholder="Select SubCategory"
      hidePlaceholder={true}
      selectionLimit={3}
      style={style}
      showArrow={true}
      customArrow={<CustomArrow />}
      customCloseIcon={<CustomCrossButton />}
      avoidHighlightFirstOption={true}
      showCheckbox={true}
      onSelect={handleSubCategoryFilter}
      onRemove={handleSubCategoryFilter}
      selectedValues={getSelectedValues()}
      selectedValueDecorator={(value: string, option: any) => {
        return (
          <CustomTooltip1 value={value} truncated={true} option={option} />
        );
      }}
    />
  );
};

export default React.memo(SubCategoryFilter);